import React from 'react';
import { useTranslation } from 'react-i18next';
import ReportCard from '../../../../components/ReportCard';
import BarrelBox from './BarrelBox';

const BarrelBoxes = ({ pitcherId, isLhb, levelId }) => {
    const { t: translate } = useTranslation();

    return (
        <ReportCard title={translate('pitcher-overview.sections.barrel-boxes')}>
            <div className="d-flex justify-content-around">
                <BarrelBox pitcherId={pitcherId} isLhh={isLhb} order={1} levelId={levelId} />
                <BarrelBox pitcherId={pitcherId} isLhh={isLhb} order={2} levelId={levelId} />
            </div>
        </ReportCard>
    );
};

export default BarrelBoxes;
